import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useYokohamaData } from "../../../lib/useMockData";

export default function AccessSection() {
  const { accessData } = useYokohamaData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-3">{accessData.label}</p>
              <h2 className="section-title">{accessData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">
                {accessData.subtitle}
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={100}>
            <div className="bg-airdoa-navy rounded-lg p-6 md:p-8 mb-8 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center text-airdoa-gold mb-3">
                <i className="ri-map-pin-line text-xl" />
              </div>
              <p className="text-xs text-white/60 mb-1">所在地</p>
              <p className="text-sm md:text-base text-white font-medium">
                {accessData.address}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {accessData.methods.map((method, idx) => (
              <ScrollReveal key={method.type} direction="up" delay={idx * 120}>
                <div className="p-6 bg-white rounded-lg h-full">
                  <div className="w-10 h-10 flex items-center justify-center text-airdoa-gold mb-4">
                    <i className={`${method.icon} text-xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy mb-2">
                    {method.title}
                  </h3>
                  <p className="text-sm text-airdoa-gray leading-[1.9]">
                    {method.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="bg-white rounded-lg p-6 md:p-8">
              <p className="text-xs text-airdoa-gray mb-4 tracking-wide">
                アクセスのヒント
              </p>
              <ul className="flex flex-col gap-3">
                {accessData.tips.map((tip) => (
                  <li
                    key={tip}
                    className="flex items-start gap-3 text-sm text-airdoa-gray"
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-airdoa-gold mt-0.5 shrink-0">
                      <i className="ri-check-line" />
                    </span>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
